





























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrganisationService } from '@store/service/OrganisationService';

/* ----------------------------------------
    Component
---------------------------------------- */

    @Component({
        methods: {
            removeUser() {
                let confirmDelete = confirm(`Weet u zeker dat u ${this.fullname} wilt verwijderen?`);

                if(!confirmDelete) {
                    return;
                }

                this.$emit('remove-user', {
                    userId: this.user.id
                });
            },
            updateUserRole() {
                let newRole = this.user.admin ? 'gebruiker' : 'beheerder';
                let changeRole = confirm(`Weet u zeker dat u de rol van ${this.fullname} wilt wijzigen naar ${newRole}?`);

                if(!changeRole) {
                    this.$root.$emit('root::dropdown::close');
                    return;
                }

                this.$emit('update-user-role', {
                    userId: this.user.id
                });

                this.$root.$emit('root::dropdown::close');
            }
        },

        computed: {
            fullname() {
                return (this.user.lastname_prefix) ? `${ this.user.initials } ${ this.user.lastname_prefix } ${ this.user.lastname }` : `${ this.user.initials } ${ this.user.lastname }`;
            }
        }
    })

/* ----------------------------------------
    Export
---------------------------------------- */

export default class UserItem extends Vue {
    @Prop() user!: object

    @Prop({ default: false }) canDelete!: boolean

    @Prop({ default: false }) canChangeRole!: boolean
};

